import React, { useEffect, useState } from "react";
import { InfoWindow, useGoogleMap } from "@react-google-maps/api";
import moment from "moment";
import { Tooltip } from "@mui/material";

const CIWFRRNew = ({ coordinates, onCloseClick, vehicleInfo }) => {
  const map = useGoogleMap();
  const [zoomLevel, setZoomLevel] = useState(map.getZoom());
  // const [address, setAddress] = useState("");

  useEffect(() => {
    const handleZoomChange = () => {
      setZoomLevel(map.getZoom());
    };

    let zoomChangeListener;
    if (window.google) {
      zoomChangeListener = map.addListener("zoom_changed", handleZoomChange);
    }

    return () => {
      if (zoomChangeListener && window.google) {
        window.google.maps.event.removeListener(zoomChangeListener);
      }
    };
  }, [map]);

  // Convert coordinates to LatLng if necessary
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const coordinatesWithLatLng = coordinates?.coordinates
    ? coordinates
    : {
        ...coordinates,
        coordinates: { lat: coordinates?.lat, lng: coordinates?.lng },
      };

  const speed = coordinates?.speed;
  const vehicleNo = vehicleInfo[0]?.vehicle_no;

  let formatedVehicleNo = [
    vehicleNo?.substring(0, 4),
    vehicleNo?.substring(4, 6),
    vehicleNo?.substring(6),
  ];

  const infoWindowStyle = {
    border: "1px solid #2c3e50",
    padding: "15px",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
    textAlign: "center",
  };

  // const detailsStyle = {
  //   fontSize: "13px",
  //   color: "#34495e",
  //   marginBottom: "10px",
  //   textAlign: "center",
  // };

  const keyframesStyle = `
    @keyframes driveVehicle {
      from { left: 0; }
      to { left: calc(100% - 20px); }
    }
  `;

  // const convertToAddress = (lat, lng) => {
  //   if (!window.google) return;
  //   const geocoder = new window.google.maps.Geocoder();
  //   const latLng = { lat: lat, lng: lng };

  //   geocoder.geocode({ location: latLng }, (results, status) => {
  //     if (status === "OK") {
  //       if (results[0]) {
  //         setAddress(results[0].formatted_address);
  //       } else {
  //         console.log("No results found");
  //       }
  //     } else {
  //       console.log("Geocoder failed due to: " + status);
  //     }
  //   });
  // };

  // useEffect(() => {
  //   if (coordinatesWithLatLng) {
  //     convertToAddress(
  //       coordinatesWithLatLng.coordinates?.lat,
  //       coordinatesWithLatLng.coordinates?.lng
  //     );
  //   }
  // }, [coordinatesWithLatLng]);

  useEffect(() => {
    if (coordinatesWithLatLng) {
      map.panTo(coordinatesWithLatLng.coordinates);
    }
  }, [coordinatesWithLatLng, map]);

  const adjustPositionUpwards = (originalPosition) => {
    const baseOffset = 0.00002; // Adjust this base offset value as needed
    const adjustedOffset = baseOffset * (22 - zoomLevel); // Adjust the multiplier as needed
    return {
      lat: originalPosition?.lat + adjustedOffset,
      lng: originalPosition?.lng,
    };
  };

  return (
    <>
      <style>{keyframesStyle}</style>
      <InfoWindow
        position={adjustPositionUpwards(coordinatesWithLatLng.coordinates)}
        onCloseClick={onCloseClick}
      >
        <div style={infoWindowStyle}>
          <Tooltip
            title={
              vehicleInfo[0]?.district_name + " | " + vehicleInfo[0]?.imei_no
            }
            placement="top"
            arrow
          >
            <div
              className="licence-plate-container"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div className="license-plate">
                <span className="license-plate-left">
                  {formatedVehicleNo[0]}
                </span>
                <div className="license-plate-middle">
                  <span className="license-plate-middle-top">
                    {formatedVehicleNo[1]}
                  </span>
                </div>
                <span className="license-plate-right">
                  {formatedVehicleNo[2]}
                </span>
              </div>
            </div>
          </Tooltip>
          <hr />
          <div
            style={{ textAlign: "center", fontSize: "12px", fontWeight: "600" }}
          >
            {moment(coordinates?._time).format("YYYY-MM-DD hh:mm:ss A")}
          </div>
          {speed && speed !== 0 ? (
            <div
              style={{
                textAlign: "center",
                fontSize: "13px",
                fontWeight: "bold",
                marginBottom: "10px",
              }}
            >
              Speed: {speed} km/h
            </div>
          ) : null}
          {/* <div style={detailsStyle}>{address}</div> */}
        </div>
      </InfoWindow>
    </>
  );
};

export default CIWFRRNew;
